export default {
  supplier: [],
  index: 0
};
